<template>
  <div>
    <div v-if="debug_show_page_name==true" style="color:green;">inventory_managment</div>
    <div :class="' container_auto ' ">
      <search-control 
        style="padding-bottom: 10px;width: 100%" 
        :field_names="allSearchFields" 
        @onSearchClear="onSearchClear"
        @change="searchControlChangedDatasource">
      </search-control>

      <ag-grid-vue 
      style="width: 100%; height: 325px;margin-left:-15px" class="ag-blue" 
      :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数　
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
      <device-management-ledger-modal tag="showInventoryManagmentModal" />
    </div>
    <div class="row" style="margin-top:20px;">
      <div class="col-xs-6"></div>
      <div class="col-xs-6">
        <button
          :disabled="true || checkUserPermission(true,permissionMode.EXPORT) == false"
          class="btn btn-primary" style="min-width:100px;float: right;margin-right: -15px;background: #b83261;background: #337ab7;" >出力</button>
        <router-link
          :disabled="checkUserPermission(acl.inventory_report_check,permissionMode.EXPORT) == false" tag="button"
          to="/inventory_report_check"
          type="button"
          style="min-width:100px;float: right;margin-right: 10px;"
          class="btn btn-primary"
          >棚卸報告確認</router-link>
        <button
          :disabled="checkUserPermission(acl.inventory_report,permissionMode.EXPORT) == false"
          class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #92D050;border-color:#92D050;"
          @click="addNewReport"
          >棚卸報告</button>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import uuid from "uuid";
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_device_embedded_information';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:inventory_managment');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import inventorySummaryBox from "@/components/inventory_summary_box";
import { bus } from '@/libs/bus';
// import subTableCertificateLedger from '@/components/sub_pages/sub-table-certificate-ledger';
// import IndividualLinkingDetails from '@/components/sub_pages/sub-table-individual-linking-details';
import deviceManagementLedgerModal from "@/components/modals/device-management-ledger-modal";

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue,
    'device-management-ledger-modal':deviceManagementLedgerModal,
    "inventory-summary-box":inventorySummaryBox
  },
  data() {
    return {
     api_name:"device_embedded_information",
      page_acl: acl.inventory,
      // execute_filter_on_back:true,
      detail_page:"page_0010_device_embedded_information_detail",
      inventory_sub_search:{}
    };
  },
  computed: {
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    allSearchFields(){
      return [
          fields.equipment_in_charge_system,
          fields.device_control_number,
          fields.computer_name,
          fields.registration_date,
          fields.manufacture_name,
          fields.model_name,
          fields.equipment_in_charge_classification,
          fields.installation_base,
          fields.user_name,      ]
    },

    tabFieldList() {
      return [
        utils.extend(fields.equipment_in_charge_system, {}),
        utils.extend(fields.device_control_number, {}),
        utils.extend(fields.computer_name, {}),
        utils.extend(fields.manufacture_name, {}),
        utils.extend(fields.model_name, {}),
        utils.extend(fields.equipment_in_charge_classification, {}),
        utils.extend(fields.installation_base, {}),
        utils.extend(fields.user_name, {}),
        utils.extend(fields.remarks, {}),
      ];
    }
  },
  methods: {
    addNewReport(){
      return this.$router.push({ name: "page_0071_inventory_report", params: {  seq_id:"new"} });
    },
    onDetailsClick(ev, data) {
      bus.$emit("showInventoryManagmentModal",{fk_id:data.seq_id});
    },
    onRowSelected(ev){
        this.selected_row = ev.node.data.seq_id;
    },
    createColumnDefs() {
        return this.commonCreateColumnDefs({show_details:true,show_checkbox:false})
    },
    onSearchClear(){
      this.emulateSearchControlChangedDatasource(true)
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    bus.$on("inventory_sub_search",(data)=>{
          this.inventory_sub_search = data.search_data;
          this.gridOptions.api.purgeInfiniteCache();
          this.countRows("inventory_managment");
    })
    this.inventory_sub_search = this.$props.searchData;
    this.emulateSearchControlChangedDatasource()
  },
  beforeDestroy() {
    bus.$off("inventory_sub_search")
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.api_request_options = {sub_search:"inventory_sub_search"};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource({load_only_with_filter:true,loaded_cb:(_err,_data)=>{
    }});
  },
  props: ["searchData"]
};
</script>

<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}

.tabs {
  margin-top: 50px;
  padding-bottom: 40px;
  background-color: #fff;
  position:relative;
			left:50px;
  /*width:400px;*/
  
  }

/*タブのスタイル*/
.tab_item {
  width:150px;
  height: 40px;
  border-bottom: 2px solid #979797;
  background-color: #5b9bd5;
  line-height: 40px;
  text-align: center;
  color: #ffffff;
  font-weight: lighter;
  display: block;

  transition: all 0.2s ease;
  border-radius: 0.75em 0.75em 0px 0px;
  display: inline-block;

}
.tab_item:hover {
  opacity: 0.75;
}

/*ラジオボタンを全て消す*/
input[name="tab_item"] {
  display: none;
}

/*タブ切り替えの中身のスタイル*/
.tab_content {
  display: none;
  padding: 40px 40px 0;
  clear: both;
  overflow: hidden;
}


/*選択されているタブのコンテンツのみを表示*/
#all:checked ~ #all_content,
#programming:checked ~ #programming_content,
#design:checked ~ #design_content {
  display: block;
}

/*選択されているタブのスタイルを変える*/
.tabs input:checked + .tab_item {
  background-color: #d9d9d9;
  color: #fff;
}
.line1{
    height: 25px;
    width: 100px;
    }
</style>


// WEBPACK FOOTER //
// inventory_management.vue?0f4f6986